export default "__VITE_ASSET__SEcSTORc__"